<fui-color-control [disabled]="isReadonly"
                   [attr.id]="elementId"
                   [label]="label" [placeholder]="placeholder"
                   [(ngModel)]="value"
                   [control]="formControl"
                   [allowAlpha]="allowAlpha"
                   [showClearIcon]="showClearOption" (onClear)="onClear.next()">
</fui-color-control>
